const password = {
    unsupported_encryption_method: 'El método de encriptación {{name}} no es compatible.',
    pepper_not_found: 'No se encontró el password pepper. Por favor revisa tus variables de entorno.',
    rejected: 'Contraseña rechazada. Por favor verifica que tu contraseña cumpla con los requisitos.',
};
export default Object.freeze(password);
